import { Directive } from '@angular/core';

@Directive({
  selector: 'iss-label,[issLabel]',
  host: { // eslint-disable-line @angular-eslint/no-host-metadata-property
    class: 'label iss-label',
  },
  standalone: true,
})
export class LabelDirective {}
